export const RECENT_ACTIVITY_LIMIT = 8;
